import SequenceConfig from "./SequenceConfig";
import BasePlayer from "../utils/BasePlayer";
import { Observable } from "rxjs";

export default class SequencePlayer extends BasePlayer {
  constructor(public config: SequenceConfig) {
    super(config);
  }
  public async start(): Promise<{}> {
    this.content.start();
    return {};
  }
  public setItemResult(result: any, itemIndex?: number): void {
    // if (playFromState) {
    //   this.content.setItemResultFromState(result);
    // } else {
    this.content.setItemResult(result, itemIndex);
    // }
  }
  public getState(): any {
    return this.content.getState();
  }
  public setState(partialState: any): void {
    this.content.setState(partialState);
  }
  public getAllResult(): any {
    return this.content.getAllResult();
  }
  public getNextQuestion(): any {
    return this.content.getNextQuestion();
  }
  public getSequencerProps(): any {
    return this.content.getSequencerProps();
  }

  public cleanup(): void {
    this.content.cleanup();
  }

  public getSequencerSubject(): Observable<any> | null {
    if (this.content) {
      return this.content.subject;
    }
    return null;
  }
}
